import BaseService from 'services/api/BaseService';
import { SsoUrls } from 'services/api/urls';
import { SsoSignInResponse } from '_technical/types/sso.types';

class SsoService {
  /**
   * Sign in to SSO platform and get redirect URL
   * @param domain - The domain of the SSO platform (e.g., "dcx.example.com")
   * @returns Promise with redirect URL
   */
  static signIn = (domain: string): Promise<SsoSignInResponse> => {
    return BaseService.getRequest(SsoUrls.SIGN_IN(domain), true);
  };
}

export default SsoService;
